import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

export default [
  {
    path: 'incidents/:definitionId?',
    name: 'incidents',
    component: () => import(/* webpackChunkName: "incident-section" */'@/components/pages/incidents/IncidentsPane.ts.vue'),
    meta: { title: 'Incidents' },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'Incidents',
    highScale: true,
  },
}));
